import { IKnmCanceledReason } from 'APIPackage/CatalogsModule/interfaces/IKnmCanceledReason';

import { IKnmCanceledReasonSelectOption } from '../interfaces/IKnmCancelledReasonsSelectOption';

export function createKnmCanceledReasonSelectOption(reason: IKnmCanceledReason): IKnmCanceledReasonSelectOption {
  return {
    ...reason,
    label: reason.name,
    value: reason.id,
  };
}
